import React from "react";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from '@mui/icons-material/Help';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import tooltipData from './Tooltip.json';

const TitleWithTooltip = (props) => {
    const [open, setOpen] = React.useState(false);
    const handleTooltipClose = () => {
        setOpen(false);
    };
    const handleTooltipOpen = () => {
        setOpen(true);
    };
    let msg = props.tooltipTitle ? tooltipData[props.tooltipTitle] : "";
    return (
        <Typography component="div" variant={props.variant ? props.variant : "body2"} className={props.class}>
            {props.title}
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <Tooltip
                    PopperProps={{
                        disablePortal: true,
                    }}
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={msg}>
                    <HelpIcon onClick={handleTooltipOpen} fontSize="small" style={{ width: '18px', height: '18px', verticalAlign: 'middle', cursor: 'pointer' }} />
                </Tooltip>
            </ClickAwayListener>
            {props.showRequired &&
                <span style={{ fontWeight: 'bold', color: 'red', paddingLeft: '2px' }}>(REQUIRED)</span>
            }
            {props.additionalText && props.additionalText != '' &&
                <span style={{ color: 'red', paddingLeft: '2px', fontStyle: 'italic' }}>{props.additionalText}</span>
            }
        </Typography>

    )
}

export default TitleWithTooltip;